// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Archivo', 'Archivo Fallback'","fontStyle":"normal"},"className":"__className_5afde0","variable":"__variable_5afde0"};